import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Radio from "@mui/material/Radio";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import CircleIcon from "@mui/icons-material/Circle";
import { DataGrid } from "@mui/x-data-grid";
import { getClassNames, joinByKeys } from "../../Js/Common";
import { getFormatedDate, getDaysDiff } from "../../Js/TimeAndDate";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { find, sortBy } from "lodash";

import {
  getMonthlyReportData,
  getMonthlyReportSite,
  getMonthlyReportLog,
} from "./Services";
import PieChart from "../Report/Trainers/PieChart";
import BarChart from "../Report/Trainers/BarChart";
import StackBarChartMonthly from "./StackBarChartMonthly";

const trainerWiseSeriesMetadata = [
  {
    name: "Assigned Assignments",
    field: "totalAssi",
  },
  {
    name: "Attempted Assignments",
    field: "attemptedAssi",
  },
];

const classWiseAssignmentSeriesMetadata = [
  {
    name: "Total Learners",
    field: "classAssignedStudents",
  },
  {
    name: "Attempted Learners",
    field: "classAttemptedStudents",
  },
];

const MonthlyReport = (props) => {
  const navigation = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { siteuuid, month, date, year, month2, year2, date2 } = useParams();
  const [countData, setCountData] = useState(null);
  const [usageData, setUsageData] = useState(null);
  const [siteConfig, setSiteConfig] = useState(null);
  const [monthLabel, setMonthLabel] = useState(null);
  const [trainerWiseAssignmentsData, setTrainerWiseAssignmentsData] = useState(
    []
  );
  const [seriesMetaData, setSeriesMetaData] = useState(
    trainerWiseSeriesMetadata
  );
  const [classWiseAssignmentsData, setClassWiseAssignmentsData] = useState([]);
  const [trainerWiseUsageData, setTrainerWiseUsageData] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    const innerFun = async () => {
      let firstDay = new Date(+year, +month, date ? date : 1);
      let lastDay = new Date(+year, +month + 1, date2 ? date2 : 0);
      if (month2 && year2) {
        lastDay = new Date(+year2, +month2 + 1, date2 ? date2 : 0);
      }

      if (getDaysDiff(firstDay, lastDay) < 0) {
        alert("Invalid URL!");
        dispatch(commonSliceActions.setLoader(false));
        return false;
      }
      console.log("::::::", {
        query: {
          site_uuid: siteuuid,
          startDate: getFormatedDate(firstDay, "YYYY-MM-DD"),
          endDate: getFormatedDate(lastDay, "YYYY-MM-DD"),
          month: month,
          year: year,
          month2: month2 ? month2 : -1,
          year2: year2 ? year2 : -1,
          date: date ? date : -1,
          date2: date2 ? date2 : -1,
        },
      });
      let res = await getMonthlyReportData({
        query: {
          site_uuid: siteuuid,
          startDate: getFormatedDate(firstDay, "YYYY-MM-DD"),
          endDate: getFormatedDate(lastDay, "YYYY-MM-DD"),
          month: month,
          year: year,
          month2: month2 ? month2 : -1,
          year2: year2 ? year2 : -1,
          date: date ? date : -1,
          date2: date2 ? date2 : -1,
        },
      });

      let siteData = await getMonthlyReportSite({
        query: {
          $select: ["keydata"],
          site_uuid: siteuuid,
          keyid: "site_config",
        },
      });

      setSiteConfig(siteData.response.data[0]["keydata"]);

      let usage = res.response.monthlyUsage;
      delete res.response.monthlyUsage;
      setUsageData(usage);
      console.log("res.response", res.response);
      setCountData(res.response);
      if (date2 && month2 && year2) {
        setMonthLabel(
          `${getFormatedDate(
            `${+month + 1}-${date}-${year}`,
            "DD-MMM-YYYY"
          )} to ${getFormatedDate(`${+month2 + 1}-${date2}-${year2}`, "DD-MMM-YYYY")}`
        );
      } else {
        setMonthLabel(getFormatedDate(`${+month + 1}-${date}-${year}`, "DD-MMM-YYYY"));
      }
      setTrainerWiseAssignmentsData(
        res.response.trainerWiseAssignments.map((val) => {
          return {
            trainerName: joinByKeys(val.name, ["firstname", "lastname"], " "),
            totalAssi: val.totalGivenAssignment,
            attemptedAssi: +val.learnerAttemptedAssignment,
          };
        })
      );

      setTrainerWiseUsageData(
        res.response.trainerWiseUsage.map((val) => {
          return {
            trainerName: joinByKeys(val.name, ["firstname", "lastname"], " "),
            courseTime: +val.courseView,
            taskTime: +val.assignment,
            assiTime: +val.task,
          };
        })
      );

      let classNames = await getClassNames(siteuuid);
      console.log("1111111", classNames);
      console.log("2222222", res.response.classWiseAssignments);
      res.response.classWiseAssignments =
        res.response.classWiseAssignments.filter((val) => {
          let foundClassObj = find(classNames, { id: val.classId });
          if (foundClassObj) {
            return val;
          }
        });
      setClassWiseAssignmentsData(
        sortBy(
          res.response.classWiseAssignments.map((val) => {
            let foundClassObj = find(classNames, { id: val.classId });
            return {
              classId: val.classId,
              className: foundClassObj ? foundClassObj.value : "Deletd Class",
              totalAssi: val.classWiseAssignedAssignments,
              attemptedAssi: +val.classWiseAttemptedAssignments,
              classWiseAssignmentData: val.classWiseAssignmentData,
            };
          }),
          ["className"]
        )
      );
      dispatch(commonSliceActions.setLoader(false));
    };
    if (siteuuid && year) {
      dispatch(commonSliceActions.setLoader(true));
      innerFun();
    }
  }, [siteuuid, month, year, date]);

  return (
    <Box
      sx={{
        backgroundImage: "url(./mainbackground.svg)",
        backgroundSize: "cover",
        height: "100vh",
      }}
    >
      <Grid container>
        <Box
           
          sx={{
            backgroundColor: "#FFFFFF",
            margin: 8,
            height: "78vh",
            borderRadius: 5,
            boxShadow: 10,
            padding: 2,
            overflow: "auto",
          }}
        >
          <Grid item sm={12} md={12}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "solid #DB8829",
                borderBottomStyle: "double",
              }}
            >
              <Grid sm={8} md={8} item sx={{ display: "flex" }}>
                {/* <IconButton onClick={() => { navigation(-1) }}>
                                    <NavigateBeforeIcon sx={{
                                        fontSize: '1.8rem', color: '#A9A9A9', '@media (min-width: 1636px)': {
                                            fontSize: '3rem'
                                        }
                                    }} />
                                </IconButton> */}
                {false && (
                  <img
                    src={require("../../assets/logo.png")}
                    alt="Vocablab"
                    loading="lazy"
                    width="8%"
                  />
                )}
                <Typography
                  sx={{
                    mt: 1,
                    color: "primary.main",
                    fontWeight: "900",
                    fontSize: "1.2rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                >
                  {siteConfig ? siteConfig.schoolName : ""}
                </Typography>
              </Grid>
              <Grid sm={4} md={4} item sx={{ textAlign: "right", pr: 4 }}>
                <img
                  src={require("../../assets/words_full.png")}
                  alt="Vocablab"
                  loading="lazy"
                  width="20%"
                />
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item sm={12} md={12}>
                        <Box sx={{ px: 2, py: 2 }}>
                            <Typography sx={{
                                color: 'primary.main', fontWeight: '600', fontSize: '1.2em', borderBottom: '1px solid #D3D3D3', '@media (min-width: 1636px)': {
                                    fontSize: '1.4rem'
                                }
                            }}>
                                Trainer | Usage Report | Jul-2024
                            </Typography>
                        </Box>
                    </Grid> */}
          <Grid container sx={{ mt: 4 }}>
            <Grid item md={6} sm={6}>
              <Box sx={{ px: 2 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2em",
                    borderBottom: "4px solid #D3D3D3",
                    borderBottomStyle: "double",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Trainer | Usage Report | {monthLabel ? monthLabel : ""}
                </Typography>
              </Box>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Grid md={12} sm={12}>
                  {usageData && (
                    <PieChart
                      pieChartData={[
                        {
                          courseTime: usageData.courseView,
                          taskTime: usageData.task,
                          assiTime: usageData.assignment,
                          evalTime: 0,
                        },
                      ]}
                      chartHeight={"400px"}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} sm={6}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                }}
              >
                <Grid xs={5}>
                  <Card
                    className={classes.card}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                     
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                         
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum}
                          sx={{ pt: 1 }}
                        >
                          <span
                            style={{
                              borderBottom: "solid #b2b2b2",
                              borderBottomStyle: "double",
                            }}
                          >
                            {countData && countData.monthlyAssignments
                              ? countData.monthlyAssignments
                              : 0}
                          </span>
                        </Typography>
                        <Typography className={classes.ModuleName}>
                          {countData && countData.totalAssignments
                            ? countData.totalAssignments
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className} sx={{ pt: 2 }}>
                        <b>Assignments Active</b>
                        <br />
                        Total Assignments
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid xs={5}>
                  <Card
                    className={classes.card}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                    
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                        
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum}
                          sx={{ pt: 1 }}
                        >
                          <span
                            style={{
                              borderBottom: "solid #b2b2b2",
                              borderBottomStyle: "double",
                            }}
                          >
                            {countData && countData.monthlyLibraryAssignments
                              ? countData.monthlyLibraryAssignments
                              : 0}
                          </span>
                        </Typography>
                        <Typography className={classes.ModuleName}>
                          {countData && countData.totalLibraryAssignments
                            ? countData.totalLibraryAssignments
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className} sx={{ pt: 2 }}>
                        <b>Library Books</b>
                        <br />
                        Total Books
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                }}
              >
                <Grid sx={{ mt: 2 }} xs={5}>
                  <Card
                    className={classes.card}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                     
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                        
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum}
                          sx={{ pt: 1 }}
                        >
                          <span
                            style={{
                              borderBottom: "solid #b2b2b2",
                              borderBottomStyle: "double",
                            }}
                          >
                            {countData && countData.monthlypractice
                              ? countData.monthlypractice
                              : 0}
                          </span>
                        </Typography>
                        <Typography className={classes.ModuleName}>
                          {countData && countData.totalpractice
                            ? countData.totalpractice
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className} sx={{ pt: 2 }}>
                        <b>Practice Assignments</b>
                        <br />
                        Total Practice Assignments
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid sx={{ mt: 2 }} xs={5}>
                  <Card
                    className={classes.card}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                   
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                         
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum}
                          sx={{ pt: 1 }}
                        >
                          <span
                            style={{
                              borderBottom: "solid #b2b2b2",
                              borderBottomStyle: "double",
                            }}
                          >
                            {countData && countData.monthlyExams
                              ? countData.monthlyExams
                              : 0}
                          </span>
                        </Typography>
                        <Typography className={classes.ModuleName}>
                          {countData && countData.totalExams
                            ? countData.totalExams
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className} sx={{ pt: 2 }}>
                        <b>E-exams</b>
                        <br />
                        Total E-exams
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              mt: 4,
              backgroundColor: "#DB8829",
              boxShadow: 1,
              border: 1,
              borderColor: "#eaeaea",
              borderRadius: 5,
              py: 1,
            }}
          >
            <Grid item md={6} sm={6} sx={{ display: "flex" }}>
              <IconButton>
                <CircleIcon
                  sx={{
                    fontSize: "1.4rem",
                    color: "#FFFFFF",
                    "@media (min-width: 1636px)": {
                      fontSize: "3rem",
                    },
                  }}
                />
              </IconButton>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "1.2rem",
                  color: "#FFFFFF",
                  fontWeight: "500",
                }}
              >
                Total Learners:{" "}
                {countData && +countData.totalLearners
                  ? +countData.totalLearners
                  : 0}
              </Typography>
            </Grid>
            <Grid item md={6} sm={6} sx={{ display: "flex" }}>
              <IconButton>
                <CircleIcon
                  sx={{
                    fontSize: "1.4rem",
                    color: "#FFFFFF",
                    "@media (min-width: 1636px)": {
                      fontSize: "3rem",
                    },
                  }}
                />
              </IconButton>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "1.2rem",
                  color: "#FFFFFF",
                  fontWeight: "500",
                }}
              >
                Total Active Learners:{" "}
                {countData && +countData.activeLearners
                  ? +countData.activeLearners
                  : 0}{" "}
                in the Month of {monthLabel ? monthLabel : ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 4 }}>
            <Grid item md={12} sm={12}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-evenly",
                }}
              >
                <Grid>
                  <Card
                    className={classes.card1}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                    
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                         
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum1}
                          sx={{ pt: 1 }}
                        >
                          {countData && +countData.learnersGivenAssignment
                            ? +countData.learnersGivenAssignment
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className1} sx={{ pt: 3 }}>
                        Assignments Given
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid sx={{}}>
                  <Card
                    className={classes.card1}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                    
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                        
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum1}
                          sx={{ pt: 1 }}
                        >
                          {countData && +countData.assignmentAttempted
                            ? +countData.assignmentAttempted
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className1} sx={{ pt: 3 }}>
                        Assignments Attempted
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid sx={{}}>
                  <Card
                    className={classes.card1}
                    sx={{
                      boxShadow: 0,
                      border: 1,
                      borderColor: "#eaeaea",
                    
                    }}
                  >
                    <CardContent sx={{ height: "9.5rem", p: 0 }}>
                      <Box
                        hover
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "primary.main",
                          px: 2,
                          paddingTop: "1rem",
                          cursor: "pointer",
                        
                        }}
                      >
                        <Typography
                          className={classes.ModuleNum1}
                          sx={{ pt: 1 }}
                        >
                          {countData && +countData.questionsAttempted
                            ? +countData.questionsAttempted
                            : 0}
                        </Typography>
                      </Box>
                      <Typography className={classes.className1} sx={{ pt: 3 }}>
                        Questions Attempted
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              mt: 4,
              backgroundColor: "#DB8829",
              boxShadow: 1,
              border: 1,
              borderColor: "#eaeaea",
              borderRadius: 5,
              py: 1,
            }}
          >
            <Grid item md={6} sm={6} sx={{ display: "flex" }}>
              <IconButton>
                <CircleIcon
                  sx={{
                    fontSize: "1.4rem",
                    color: "#FFFFFF",
                    "@media (min-width: 1636px)": {
                      fontSize: "3rem",
                    },
                  }}
                />
              </IconButton>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "1.2rem",
                  color: "#FFFFFF",
                  fontWeight: "500",
                }}
              >
                Total Trainers:{" "}
                {countData && +countData.totalTrainers
                  ? +countData.totalTrainers
                  : 0}
              </Typography>
            </Grid>
            <Grid item md={6} sm={6} sx={{ display: "flex" }}>
              <IconButton>
                <CircleIcon
                  sx={{
                    fontSize: "1.4rem",
                    color: "#FFFFFF",
                    "@media (min-width: 1636px)": {
                      fontSize: "3rem",
                    },
                  }}
                />
              </IconButton>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "1.2rem",
                  color: "#FFFFFF",
                  fontWeight: "500",
                }}
              >
                Total Active Trainers:{" "}
                {countData && +countData.activeTrainers
                  ? +countData.activeTrainers
                  : 0}{" "}
                in the Month of {monthLabel ? monthLabel : ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{ mt: 2, backgroundColor: "#F5F7FF", borderRadius: 2 }}
          >
            <Grid item sm={12} md={12}>
              <Box sx={{ px: 2, py: 2 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2em",
                    borderBottom: "4px solid #D3D3D3",
                    borderBottomStyle: "double",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Trainer-wise | Usage Report | {monthLabel ? monthLabel : ""}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              sm={12}
              md={12}
               
              sx={{
                textAlign: "center",
                overflowX: "auto",
                overflowY: "hidden",
              }}
            >
              <StackBarChartMonthly
                stackBarData={
                  trainerWiseUsageData.length > 0 ? trainerWiseUsageData : []
                }
                isHorizontal={false}
                chartWidth={
                  trainerWiseUsageData.length <= 10
                    ? "95%"
                    : `${+trainerWiseUsageData.length * 8}%`
                }
                columnWidth={"40%"}
                chartHeight={"500px"}
              />
            </Grid>
          </Grid>
          <Grid
            container
            sx={{ mt: 2, backgroundColor: "#F5F7FF", borderRadius: 2 }}
          >
            <Grid item sm={12} md={12}>
              <Box sx={{ px: 2, py: 2 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2em",
                    borderBottom: "4px solid #D3D3D3",
                    borderBottomStyle: "double",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Trainer-wise | Assignment Report |{" "}
                  {monthLabel ? monthLabel : ""}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              sm={12}
              md={12}
               
              sx={{
                textAlign: "center",
                overflowX: "auto",
                overflowY: "hidden",
              }}
            >
              <BarChart
                barData={
                  trainerWiseAssignmentsData.length > 0
                    ? trainerWiseAssignmentsData
                    : []
                }
                isHorizontal={false}
                chartWidth={
                  trainerWiseAssignmentsData.length <= 10
                    ? "95%"
                    : `${+trainerWiseAssignmentsData.length * 8}%`
                }
                columnWidth={"40%"}
                chartHeight={"500px"}
                seriesMetaData={seriesMetaData}
                labelField={"trainerName"}
              />
            </Grid>
          </Grid>
          <Grid
            container
            sx={{ mt: 4, backgroundColor: "#F5F7FF", borderRadius: 2 }}
          >
            <Grid item sm={12} md={12}>
              <Box sx={{ px: 2, py: 2 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2em",
                    borderBottom: "4px solid #D3D3D3",
                    borderBottomStyle: "double",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Class-wise | Assignment Report |{" "}
                  {monthLabel ? monthLabel : ""}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              sm={12}
              md={12}
               
              sx={{
                textAlign: "center",
                overflowX: "auto",
                overflowY: "hidden",
              }}
            >
              <BarChart
                click={(e) => {
                  setSelectedClass(classWiseAssignmentsData[e]);
                }}
                barData={
                  classWiseAssignmentsData.length > 0
                    ? classWiseAssignmentsData
                    : []
                }
                isHorizontal={false}
                chartWidth={
                  classWiseAssignmentsData.length <= 10
                    ? "95%"
                    : `${+classWiseAssignmentsData.length * 8}%`
                }
                columnWidth={"40%"}
                chartHeight={"500px"}
                seriesMetaData={seriesMetaData}
                labelField={"className"}
              />
            </Grid>
          </Grid>
          {selectedClass && (
            <Grid
              container
              sx={{ mt: 4, backgroundColor: "#F5F7FF", borderRadius: 2 }}
            >
              <Grid item sm={12} md={12}>
                <Box sx={{ px: 2, py: 2 }}>
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontWeight: "600",
                      fontSize: "1.2em",
                      borderBottom: "4px solid #D3D3D3",
                      borderBottomStyle: "double",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    {selectedClass.className} | Assignment Report |{" "}
                    {monthLabel ? monthLabel : ""}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                sm={12}
                md={12}
                 
                sx={{
                  textAlign: "center",
                  overflowX: "auto",
                  overflowY: "hidden",
                }}
              >
                <BarChart
                  barData={
                    selectedClass["classWiseAssignmentData"].length > 0
                      ? selectedClass["classWiseAssignmentData"]
                      : []
                  }
                  isHorizontal={false}
                  chartWidth={
                    selectedClass["classWiseAssignmentData"].length <= 10
                      ? "95%"
                      : `${
                          +selectedClass["classWiseAssignmentData"].length * 8
                        }%`
                  }
                  columnWidth={"40%"}
                  chartHeight={"500px"}
                  seriesMetaData={classWiseAssignmentSeriesMetadata}
                  labelField={"assignmentName"}
                />
              </Grid>
            </Grid>
          )}
          {/* <Grid
            container
            sx={{ mt: 4, backgroundColor: "#F5F7FF", borderRadius: 2 }}
          >
            <Grid item sm={12} md={12}>
              <Box sx={{ px: 2, py: 2 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2em",
                    borderBottom: "4px solid #D3D3D3",
                    borderBottomStyle: "double",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Class Wise
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={12} md={12}>
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 5 },
                    },
                  }}
                  pageSizeOptions={[5, 10]}
                  checkboxSelection
                />
              </div>
            </Grid>
          </Grid> */}

          {/* <Grid
            container
            sx={{ mt: 4, backgroundColor: "#F5F7FF", borderRadius: 2 }}
          >
            <Grid item sm={12} md={12}>
              <Box sx={{ px: 2, py: 2 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "600",
                    fontSize: "1.2em",
                    borderBottom: "4px solid #D3D3D3",
                    borderBottomStyle: "double",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Trainer Wise
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={12} md={12}>
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 5 },
                    },
                  }}
                  pageSizeOptions={[5, 10]}
                  checkboxSelection
                />
              </div>
            </Grid>
          </Grid> */}
          <Grid container sx={{ mt: 4 }}>
            <Grid item sm={12} md={12}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderTop: "solid #DB8829",
                  borderTopStyle: "double",
                  pt: 2,
                }}
              >
                <Grid sm={8} md={8} item sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "primary.main",
                      fontWeight: "500",
                      fontSize: "1.2rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    wordsworthelt.com
                  </Typography>
                </Grid>
                <Grid sm={4} md={4} item sx={{ textAlign: "right", pr: 4 }}>
                  <img
                    src={require("../../assets/logo.png")}
                    alt="Vocablab"
                    loading="lazy"
                    width="20%"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  card: {
    backgroundColor: "#fff",
    width: "14rem",
    height: "12rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  card1: {
    backgroundColor: "#fff",
    width: "20rem",
    height: "12rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  ModuleNum: {
    fontSize: "2.4rem",
    textAlign: "center",
    fontWeight: "900",
  },
  ModuleNum1: {
    fontSize: "4rem",
    textAlign: "center",
    fontWeight: "900",
    height: "6rem",
  },
  ModuleName: {
    fontSize: "1.4rem",
    textAlign: "center",
    fontWeight: "600",
    paddingBottom: 10,
  },
  cardText: {
    fontSize: "0.9rem",
    textAlign: "center",
    paddingTop: 10,
    fontWeight: "500",
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "0.9rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "500",
  },
  className1: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "1.2rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "600",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      textAlign: "left",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  
  },
});

export default MonthlyReport;
